import { render, staticRenderFns } from "./TheSalonItem.vue?vue&type=template&id=0cc70e45"
import script from "./TheSalonItem.vue?vue&type=script&lang=js"
export * from "./TheSalonItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports